// changed by Cursor: migrate to TanStack React Query tanpa cache
import { useQuery } from '@tanstack/react-query';
import { getDashboardInit } from '../services/reportApi';

// Custom hook menggunakan React Query tanpa cache
export const useDashboardData = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['dashboard-init'],
    queryFn: async () => {
      console.log('📡 Fetching dashboard init data...');
      const response = await getDashboardInit();
      
      if (!response.success) {
        // Check if error is about learner-id - don't retry/poll if init failed
        const errorMessage = response.message || '';
        const isLearnerIdError = errorMessage.toLowerCase().includes('learner-id') || 
                                 errorMessage.toLowerCase().includes('learner id');
        
        if (isLearnerIdError) {
          console.log('❌ Init failed due to learner-id error, stopping refetch');
        }
        
        throw new Error(response.message || 'Failed to load dashboard data');
      }
      
      console.log('✅ Dashboard data retrieved:', response.data);
      
      // Save universal-learning-id to localStorage if available
      const universalLearningId = response.data?.data?.['universal-learning-id'] || 
                                   response.data?.['universal-learning-id'] ||
                                   response.data?.universalLearningId;
      if (universalLearningId) {
        localStorage.setItem('universal-learning-id', universalLearningId);
        console.log('💾 Saved universal-learning-id to localStorage:', universalLearningId);
      }
      
      return response.data;
    },
    // Disable cache: selalu fetch fresh data
    gcTime: 0, // Garbage collection time: 0 = tidak cache
    staleTime: 0, // Data langsung dianggap stale, selalu refetch
    // changed by Cursor: disable auto-refetch jika init gagal (learner-id error)
    refetchOnWindowFocus: (query) => {
      // Don't refetch if previous query failed with learner-id error
      const errorMessage = query.state.error?.message || '';
      const isLearnerIdError = errorMessage.toLowerCase().includes('learner-id') || 
                               errorMessage.toLowerCase().includes('learner id');
      return !isLearnerIdError;
    },
    refetchOnMount: (query) => {
      const errorMessage = query.state.error?.message || '';
      const isLearnerIdError = errorMessage.toLowerCase().includes('learner-id') || 
                               errorMessage.toLowerCase().includes('learner id');
      return !isLearnerIdError;
    },
    refetchOnReconnect: (query) => {
      const errorMessage = query.state.error?.message || '';
      const isLearnerIdError = errorMessage.toLowerCase().includes('learner-id') || 
                               errorMessage.toLowerCase().includes('learner id');
      return !isLearnerIdError;
    },
    retry: (failureCount, error) => {
      // Don't retry if error is about learner-id
      const errorMessage = error?.message || '';
      const isLearnerIdError = errorMessage.toLowerCase().includes('learner-id') || 
                               errorMessage.toLowerCase().includes('learner id');
      return !isLearnerIdError && failureCount < 3;
    },
  });

  return {
    loading: isLoading,
    data: data || null,
    error: error?.message || null,
    subcourses: data?.data?.subcourses || [],
    refetch, // Expose refetch untuk manual refresh jika diperlukan
  };
};

// Fungsi untuk clear cache (untuk backward compatibility)
export const clearDashboardCache = () => {
  // Tidak perlu lagi karena tidak ada cache
  console.log('⚠️ clearDashboardCache called but cache is disabled');
};

